import React, { useEffect, useRef } from 'react';
import './UserMenu.css';

function UserMenu({ user, isOpen, isOperator, onClose, onNavigate, onLogout }) {
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        onClose();
      }
    };

    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('keydown', handleEscape);
      // スマホでのスクロール防止
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const handleItemClick = (action) => {
    onClose();
    action();
  };

  // ユーザー情報の取得
  const displayName = user?.display_name || user?.username || user?.email?.split('@')[0] || 'ユーザー';
  const username = user?.username || '';

  return (
    <>
      {/* オーバーレイ（スマホ用） */}
      <div className="user-menu-overlay" onClick={onClose} />

      {/* メニュー本体 */}
      <div className="user-menu" ref={menuRef}>
        <div className="user-menu-header">
          <h3>👤 {displayName}</h3>
          {username && <p>{username}</p>}
        </div>

        <div className="user-menu-items">
          <button
            className="user-menu-item"
            onClick={() => handleItemClick(() => onNavigate('profile'))}
          >
            👤 マイプロフィール
          </button>
          {user?.role === 'admin' && (
            <button
              className="user-menu-item"
              onClick={() => handleItemClick(() => onNavigate('settings'))}
            >
              ⚙️ 設定
            </button>
          )}
          {isOperator && (
            <button
              className="user-menu-item"
              onClick={() => handleItemClick(() => onNavigate('operator'))}
            >
              🛠 運営管理
            </button>
          )}
          <button
            className="user-menu-item logout"
            onClick={() => handleItemClick(onLogout)}
          >
            🚪 ログアウト
          </button>
        </div>
      </div>
    </>
  );
}

export default UserMenu;